import Api from '@/common/api.helper'

export default {
  state: {
    campaigns: [],
    sendCampaig: []
  },
  actions: {
    loadCampaigns ({ commit }, params) {
      return Api.get('/campaigns/website?slug=' + params).then(response => {
        commit('setCampaigns', response.data)
        return response
      })
    },
    sendCampaig ({ commit }, params) {
      return Api.post('/contact/sendcampaig', params.data).then(response => {
        commit('setSendCampaig', response.data)
        return response
      })
    }
  },
  mutations: {
    setCampaigns (state, campaigns) {
      state.campaigns = campaigns
    },
    setSendCampaig (state, sendCampaig) {
      state.sendCampaig = sendCampaig
    }
  },
  getters: {
    campaigns (state) {
      return state.campaigns
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/campaig.js